import React from "react";
import Header3 from "@components/text/Header3/Header3";
import styles from "./WelcomeTitle.module.css";

const WelcomeTitle: React.FC = () => {
    return (
        <div className={styles.headerContainer}>
            <img
                src="/assets/images/fioh-logo-transparent.png"
                alt="Logo"
                className={styles.logoImage}
            />
            <h1>Forever In Our Hearts</h1>
            <Header3>Memorial Hub</Header3>
        </div>
    );
};

export default WelcomeTitle;
